/* PBC filter search (Oct 31 2026): adds a "Search <Filter>" box to long filter option lists.
   v2: for Characters, Series, Story Arc, Writer and Artist it also lazily loads the FULL value list
   (only after the first keystroke) so values beyond the storefront's 100-per-filter cap can be found. */
(function () {
  var MIN = 9, MAX_EXTRA = 25;
  var SOURCES = {
    'filter.p.m.book.characters': { view: 'pbc-mo-c', key: 'v', gid: true, global: true },
    'filter.p.m.book.series': { view: 'pbc-mo-s', key: 'v', gid: true, global: true },
    'filter.p.m.book.story_arcs': { view: 'pbc-mo-a', key: 'v', gid: true, global: true },
    'filter.p.m.custom.writer': { view: 'pbc-people', key: 'w' },
    'filter.p.m.custom.artist': { view: 'pbc-people', key: 'a' }
  };
  var mem = {};
  function norm(s) { return (s || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim(); }
  function collPath() {
    var m = location.pathname.match(/^(?:\/[a-z]{2}(?:-[a-z]{2})?)?\/collections\/[^\/]+/i);
    return m ? m[0] : null;
  }
  function getJSON(url) {
    return fetch(url, { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error('pbc-fs ' + r.status); return r.json(); });
  }
  /* metaobject endpoints: follow paginate.next.url (param name is hashed by Shopify) */
  function loadChain(url, out) {
    return getJSON(url).then(function (d) {
      out = out.concat(d.v || []);
      return d.next ? loadChain(d.next, out) : out;
    });
  }
  /* writer/artist endpoint: pages are plain ?page=N, fetch in parallel after page 1 */
  function loadPeople(base) {
    return getJSON(base + 'page=1').then(function (d1) {
      var reqs = [];
      for (var i = 2; i <= (d1.pages || 1); i++) reqs.push(getJSON(base + 'page=' + i));
      return Promise.all(reqs).then(function (rest) {
        var w = {}, a = {};
        [d1].concat(rest).forEach(function (d) { (d.w || []).forEach(function (x) { if (x) w[x] = 1; }); (d.a || []).forEach(function (x) { if (x) a[x] = 1; }); });
        return { w: Object.keys(w), a: Object.keys(a) };
      });
    });
  }
  function loadSource(src) {
    var path = src.global ? '/collections/all' : collPath();
    if (!path) return Promise.resolve(null);
    var ck = 'pbcfs2:' + src.view + ':' + path;
    if (mem[ck]) return mem[ck];
    try { var c = sessionStorage.getItem(ck); if (c) { mem[ck] = Promise.resolve(JSON.parse(c)); return mem[ck]; } } catch (e) {}
    var p;
    if (src.view === 'pbc-people') {
      p = loadPeople(path + '?view=pbc-people&');
    } else {
      p = loadChain(path + '?view=' + src.view, []).then(function (rows) {
        return { v: rows.map(function (r) { return ['gid://shopify/Metaobject/' + r[0], r[1]]; }) };
      });
    }
    p = p.then(function (d) { try { sessionStorage.setItem(ck, JSON.stringify(d)); } catch (e) {} return d; })
         .catch(function () { delete mem[ck]; return null; });
    mem[ck] = p;
    return p;
  }
  function goTo(name, value) {
    var u = new URL(location.href);
    u.searchParams.delete('page');
    var cur = u.searchParams.getAll(name);
    if (cur.indexOf(value) === -1) u.searchParams.append(name, value);
    location.href = u.toString();
  }
  function renderExtra(ctx, q) {
    var more = ctx.more;
    more.innerHTML = '';
    more.hidden = true;
    if (!q || !ctx.full) return 0;
    var rows = ctx.src.gid ? ctx.full.v : (ctx.full[ctx.src.key] || []).map(function (x) { return [x, x]; });
    if (!rows) return 0;
    var have = {};
    ctx.list.querySelectorAll('input[type=checkbox]').forEach(function (i) { have[i.value] = 1; });
    var hits = rows.filter(function (r) { return !have[r[0]] && norm(r[1]).indexOf(q) !== -1; })
      .sort(function (x, y) { var a = norm(x[1]).indexOf(q) === 0 ? 0 : 1, b = norm(y[1]).indexOf(q) === 0 ? 0 : 1; return a - b || (x[1] > y[1] ? 1 : -1); });
    if (!hits.length) return 0;
    var head = document.createElement('li');
    head.className = 'pbc-fs__more-head';
    head.textContent = 'More ' + ctx.name.toLowerCase() + ' (not in the list above)';
    more.appendChild(head);
    hits.slice(0, MAX_EXTRA).forEach(function (r) {
      var li = document.createElement('li');
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'pbc-fs__more-btn link';
      b.textContent = r[1];
      b.setAttribute('aria-label', 'Filter by ' + ctx.name + ': ' + r[1]);
      b.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); goTo(ctx.param, r[0]); });
      li.appendChild(b);
      more.appendChild(li);
    });
    if (hits.length > MAX_EXTRA) {
      var li2 = document.createElement('li');
      li2.className = 'pbc-fs__more-head';
      li2.textContent = (hits.length - MAX_EXTRA) + ' more - keep typing to narrow';
      more.appendChild(li2);
    }
    more.hidden = false;
    return hits.length;
  }
  function filterList(ctx, raw) {
    var q = norm(raw), list = ctx.list, shown = 0;
    list.classList.toggle('pbc-fs-active', q !== '');
    list.querySelectorAll(':scope > li').forEach(function (li) {
      var txt = li.getAttribute('data-pbc-fs-text');
      if (txt === null) { txt = norm(li.textContent.replace(/\(\d+\)/g, '')); li.setAttribute('data-pbc-fs-text', txt); }
      var ok = !q || txt.indexOf(q) !== -1;
      li.classList.toggle('pbc-fs-hide', !ok);
      if (ok) shown++;
    });
    var extra = 0;
    if (ctx.src && q) {
      if (ctx.full === undefined) {
        ctx.full = null;
        ctx.loading = true;
        ctx.status.textContent = 'Searching all ' + ctx.name.toLowerCase() + '…';
        ctx.status.hidden = false;
        loadSource(ctx.src).then(function (d) {
          ctx.loading = false;
          ctx.full = d || false;
          filterList(ctx, ctx.input.value);
        });
        return;
      }
      extra = renderExtra(ctx, q);
    } else if (ctx.more) { ctx.more.innerHTML = ''; ctx.more.hidden = true; }
    if (ctx.loading) return;
    ctx.status.textContent = 'No matches';
    ctx.status.hidden = !(q && shown === 0 && extra === 0);
  }
  function enhance(details) {
    if (details.querySelector('.pbc-fs')) return;
    var list = details.querySelector('ul.facets__list, ul.mobile-facets__list');
    if (!list || list.querySelectorAll(':scope > li').length < MIN) return;
    var sum = details.querySelector('summary');
    var name = sum ? (sum.querySelector('.facets__summary-label, .mobile-facets__summary-label, span') || sum).textContent.replace(/\(\d+\)|\d+ selected/gi, '').trim() : 'options';
    name = name.split('\n')[0].trim();
    var cb = list.querySelector('input[type=checkbox][name]');
    var param = cb ? cb.name : null;
    var ctx = { list: list, name: name, param: param, src: param ? SOURCES[param] : null };
    var wrap = document.createElement('div');
    wrap.className = 'pbc-fs';
    var input = document.createElement('input');
    input.type = 'search';
    input.className = 'pbc-fs__input';
    input.placeholder = 'Search ' + name;
    input.setAttribute('aria-label', 'Search ' + name);
    input.setAttribute('autocomplete', 'off');
    input.setAttribute('form', 'pbc-fs-noform');
    ctx.input = input;
    var note = document.createElement('p');
    note.className = 'pbc-fs__none';
    note.textContent = 'No matches';
    note.hidden = true;
    note.setAttribute('role', 'status');
    note.setAttribute('aria-live', 'polite');
    ctx.status = note;
    wrap.appendChild(input);
    list.parentNode.insertBefore(wrap, list);
    var after = list.nextSibling;
    if (ctx.src) {
      var more = document.createElement('ul');
      more.className = 'pbc-fs__more list-unstyled';
      more.hidden = true;
      more.setAttribute('aria-label', 'More ' + name);
      ctx.more = more;
      list.parentNode.insertBefore(more, after);
    }
    list.parentNode.insertBefore(note, after);
    ['input', 'change', 'keyup'].forEach(function (ev) {
      input.addEventListener(ev, function (e) { e.stopPropagation(); if (ev === 'input') filterList(ctx, input.value); });
    });
    input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); e.stopPropagation(); } if (e.key === 'Escape' && input.value) { e.stopPropagation(); input.value = ''; filterList(ctx, ''); } });
    input.addEventListener('search', function (e) { e.stopPropagation(); filterList(ctx, input.value); });
  }
  function run() {
    document.querySelectorAll('details.facets__disclosure, details.mobile-facets__details').forEach(enhance);
  }
  var t;
  function schedule() { clearTimeout(t); t = setTimeout(run, 50); }
  function init() {
    run();
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) { if (muts[i].addedNodes.length) { schedule(); return; } }
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
